import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@unite-us/ui';
var ConsentContent = function ConsentContent(_ref) {
  var handleDeclineClientAgreement = _ref.handleDeclineClientAgreement,
    handleApproveClientAgreement = _ref.handleApproveClientAgreement;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("p", null, "We use this survey to understand needs our [Members / patients / clients] have which could interfere with good health. We may share your answers with your other healthcare providers, and with your health plan and social services organizations, so they can determine if you qualify for any free non-medical services that could be helpful. Please check this box if you agree to continue. You can choose not to answer this survey, but we can only check for services if you do answer.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "You can choose to be screened later and may be eligible for extra services at that time. None of this will affect your ongoing Medicaid eligibility.")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end space-x-4"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Decline",
    onClick: handleDeclineClientAgreement,
    secondary: true,
    outline: true
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Accept",
    onClick: handleApproveClientAgreement,
    primary: true
  })));
};
ConsentContent.propTypes = {
  handleDeclineClientAgreement: PropTypes.func.isRequired,
  handleApproveClientAgreement: PropTypes.func.isRequired
};
export default ConsentContent;
//# sourceMappingURL=ConsentContent.js.map